<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage viewpage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card ">
                    <form [formGroup]="userForm" *ngIf="this.userForm" (ngSubmit)="onSubmit()">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    View Admin
                                </h3>
                            </div>
                        </div>

                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4">
                                    <label for="firstName">First Name </label>
                                    <input formControlName="firstName" type="text" pInputText class="form-control"
                                        readonly [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }">
                                    <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                        <div *ngIf="f.firstName.errors.required">First Name is required</div>
                                        <div *ngIf="f.firstName.errors">Numbers, Space and Special characters not
                                            allowed.
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="lastName">Last Name </label>
                                    <input formControlName="lastName" type="text" pInputText class="form-control"
                                        readonly [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }">
                                    <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                        <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                                        <div *ngIf="f.lastName.errors">Numbers, Space and Special characters not
                                            allowed.
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="email">Email Id</label>
                                    <input formControlName="email" type="text" pInputText readonly
                                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                        <div *ngIf="f.email.errors.required">Email is required</div>
                                        <div *ngIf="f.email.errors.email">Enter valid email address</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="mobileNumber">Mobile Number </label>
                                    <input formControlName="mobileNumber" readonly type="text" minlength="10"
                                        maxlength="12" pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.mobileNumber.errors }">
                                    <div *ngIf="submitted && f.mobileNumber.errors" class="invalid-feedback">
                                        <div *ngIf="f.mobileNumber.errors.required">Mobile Number is required</div>
                                        <div *ngIf="f.mobileNumber.errors">Please Check Mobile Number</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4 addFormDropDown ">
                                    <label for="country">Country </label>
                                    <p-dropdown inputId="country" readonly [options]="countrylist"
                                        formControlName="country" placeholder="Select" optionLabel="name"></p-dropdown>

                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="state">State</label>
                                    <p-dropdown inputId="state" [filter]="true" [options]="statelist"
                                        formControlName="state" placeholder="Select" optionLabel="name"></p-dropdown>
                                    <!-- <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                            <div *ngIf="f.state.errors.required">Please, Select State</div>
                        </div> -->
                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="city">City</label>
                                    <p-dropdown inputId="city" [filter]="true" readonly [options]="citylist"
                                        formControlName="city" placeholder="Select" optionLabel="name"></p-dropdown>
                                    <!-- <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                            <div *ngIf="f.city.errors.required">Please, Select City</div>
                        </div> -->
                                </div>

                                <div class="p-field p-col-4">
                                    <label for="zipcode">Zipcode</label>
                                    <input formControlName="zipcode" type="text" readonly maxlength="10" pInputText
                                        class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.zipcode.errors }">
                                </div>
                                <div class="p-field p-col-8">
                                    <label for="textarea">Address</label>
                                    <textarea inputId="textarea" rows="3" readonly cols="30" class="form-control"
                                        formControlName="address" pInputTextarea></textarea>
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4 addFormDropDown ">
                                    <label for="textarea">Gender </label>
                                    <p-dropdown inputId="gender" [options]="genders" formControlName="gender" readonly
                                        placeholder="Select" optionLabel="name"
                                        [ngClass]="{ 'is-invalid': submitted && f.gender.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                                        <div *ngIf="f.gender.errors.required">Please, Select Gender</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4">
                                    <label for="dob">DOB </label>
                                    <p-calendar formControlName="dob" class="p-calendar" monthNavigator="true"
                                        yearNavigator="true" yearRange="{{yearRange}}" inputId="calendar"
                                        dateFormat="dd-mm-yy" [defaultDate]="myDate" [showIcon]="true"
                                        (onSelect)="setDOB($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.dob.errors }"></p-calendar>
                                    <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                                        <div *ngIf="f.dob.errors.required">Please, Enter Dob</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="textarea">Timezone<span class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="timezone" [options]="timeZoneArray" formControlName="timeZone"
                                        placeholder="Select" optionLabel="name"
                                        [ngClass]="{ 'is-invalid': submitted && f.timeZone.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.timeZone.errors" class="invalid-feedback">
                                        <div *ngIf="f.timeZone.errors.required">Please, Select TimeZone</div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="p-field p-col-4">
                                <label for="status">Status</label>
                                <p-dropdown inputId="status" [options]="statuses" formControlName="status" readonly
                                    placeholder="Select" optionLabel="label"></p-dropdown>
                                <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                    <div *ngIf="f.status.errors.required">Please, Select Status</div>
                                </div>
                            </div> -->
                        </div>
   <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4 uploadBtn">
                                    <div class="subTitleLable">
                                        <h4>Upload Profile Photo</h4>
                                    </div>

                                    <div class="column banner-images col mt-3">
                                        <div class="imagediv">
                                            <img class="thumbnail-image" src="{{ imageProfile }}" />
                                            <!-- <ul class="actionList">
                                                <li>
                                                    <button type="button" class="editBtn"><img
                                                            src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
                                                </li>
                                                <li>
                                                    <button type="button" class="deleteBtn"><img
                                                            src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                                </li>
                                            </ul> -->
                                        </div>

                                    </div>

                                    <!-- <img src="{{ imageProfile }}" alt="freya-layout" height="100px" /> -->
                                </div>
                            </div>
                        <!-- <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-4" *ngIf="showProfile">
                                <img src="{{ imageProfile }}" alt="freya-layout" height="100px" />
                            </div>

                        </div> -->
                        <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
                            <div class="d-flex">
                                <span *ngIf="!categoryDefault"  >
                                    <button  (click)="editAdmin(adminId)"  class="p-button-info save-btn p-mr-3">
                                        <img src="../../../assets/images/backend-image/common-images/editeBtn.svg" alt=""> Edit
                                    </button> 
                                </span>
                                <!-- <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="userForm.invalid"></button> -->
                                <!-- <button pButton pRipple label="Reset" icon="pi pi-times" type="reset" (click)="onReset()"></button> -->
                                <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                                    class="cancel-btn" (click)="backLink()"></button>
                            </div>
                        </div> 
                    </form>
                </div> 
            </div>
        </div>
    </div>
</div>